import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import { Space } from 'antd';
import { VoiceRecordArea } from './voice-record-area.component';
import styled from '@xstyled/styled-components';
import { AppModal, Heading3, PrimaryButton, SecondaryButton } from '@lib/common';
import { LoadingOutlined } from '@ant-design/icons';
import { Size } from '../../../file-storage/src';
import { AudioFileEdit } from '../../../form-components/src/audio-file';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledModal = styled(AppModal)(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
var StyledLoadingIcon = styled(LoadingOutlined)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: 24px;\n"])));
var StyledSpace = styled(Space)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  min-width: 450px;\n  min-height: 150px;\n  text-align: center;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  .ant-space-item {\n    width: 90%;\n  }\n"])));
export var VoiceRecordModal = function VoiceRecordModal(props) {
  var isOpen = props.isOpen,
      label = props.label,
      onCancel = props.onCancel,
      isPermissionDenied = props.isPermissionDenied,
      isRecording = props.isRecording,
      onClick = props.onClick,
      onDelete = props.onDelete,
      onSave = props.onSave,
      isLoading = props.isLoading,
      audioFile = props.audioFile,
      uploadedFile = props.uploadedFile,
      isSaving = props.isSaving,
      isDeleting = props.isDeleting;

  var renderFooter = function renderFooter() {
    var isNoRecordFile = !audioFile && !uploadedFile;

    if (isNoRecordFile) {
      return null;
    }

    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(SecondaryButton, {
        onClick: onCancel,
        disabled: isSaving || isDeleting,
        size: "middle",
        children: label.cancel
      }), /*#__PURE__*/_jsx(PrimaryButton, {
        size: "middle",
        disabled: !uploadedFile || isDeleting,
        loading: isSaving,
        onClick: onSave,
        children: label.save
      })]
    });
  };

  var renderModalContent = function renderModalContent() {
    if (isLoading) {
      return /*#__PURE__*/_jsxs(StyledSpace, {
        direction: "vertical",
        size: "small",
        children: [/*#__PURE__*/_jsx(StyledLoadingIcon, {}), label.uploading]
      });
    }

    var audioFileLabel = {
      deleteTitle: label.deleteConfirmation,
      deleteOk: label.yes,
      deleteCancel: label.no
    };

    if (uploadedFile) {
      return /*#__PURE__*/_jsx(AudioFileEdit, {
        source: uploadedFile.url,
        fileSize: Size.format(uploadedFile.fileInformation.size),
        fileName: '',
        onDelete: onDelete,
        label: audioFileLabel,
        isLoading: isDeleting
      });
    }

    if (audioFile) {
      return /*#__PURE__*/_jsx(AudioFileEdit, {
        source: audioFile.url,
        fileSize: Size.format(audioFile === null || audioFile === void 0 ? void 0 : audioFile.size),
        fileName: '',
        onDelete: onDelete,
        label: audioFileLabel,
        isLoading: isDeleting
      });
    }

    return /*#__PURE__*/_jsx(VoiceRecordArea, {
      isRecording: isRecording,
      label: label,
      onClick: onClick,
      isDenied: isPermissionDenied
    });
  };

  return /*#__PURE__*/_jsxs(StyledModal, {
    open: isOpen,
    centered: true,
    onCancel: onCancel,
    footer: renderFooter(),
    destroyOnClose: true,
    children: [/*#__PURE__*/_jsx(Heading3, {
      children: label.voiceRecord
    }), renderModalContent()]
  });
};